import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ToastService } from '@teorema/patron';
import { Observable } from 'rxjs';
import { constants, UserService } from 'src/app/shared';
@Injectable()
export class UserSellerGuard {
  constructor(
    private userService: UserService,
    private toastService: ToastService
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return new Promise(async (resolve, reject) => {
      let hasSeller = await this.checkHasSeller();
      resolve(!hasSeller);
    });
  }

  private async getCachedHasSeller(userId?: string): Promise<any> {
    let cache = localStorage.getItem(constants.hasSeller);
    if (cache) {
      let cachedObj;

      try {
        cachedObj = JSON.parse(cache);
      } catch (e) {}

      if (cachedObj) {
        if (userId) {
          return cachedObj[userId];
        } else {
          return cachedObj;
        }
      }
    }

    return undefined;
  }

  private async fetchHasSeller(userId: string, cachedObj?: any) {
    let response = await this.userService.hasSeller(userId);

    if (response) {
      if (!cachedObj) {
        cachedObj = {};
      }
      cachedObj[userId] = response?.result;
      localStorage.setItem(constants.hasSeller, JSON.stringify(cachedObj));
    }

    return response?.result as boolean;
  }

  private async checkHasSeller() {
    let user = await this.userService.getCurrentUser();

    if (!user || !user.id) {
      return false;
    }

    let hasSeller: boolean | null = null;
    let cachedObj = await this.getCachedHasSeller();

    if (cachedObj) {
      hasSeller = cachedObj[user.id];
    }

    if (hasSeller === null || hasSeller === undefined) {
      hasSeller = await this.fetchHasSeller(user.id, cachedObj);
    }

    if (hasSeller) {
      this.toastService.show({
        message: 'Usuário não possui permissão de acesso ao módulo (usuário possui vendedor)',
        color: 'error',
      });
    }

    return hasSeller;
  }
}
